"use client";
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resetPassword, isLoading, message } = useAuth();

  // Get email from state (passed from ForgotPassword page)
  const email = location.state?.email || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  if (newPassword !== confirmPassword) {
    setError("Passwords do not match");
    return;
  }

  const token = location.state?.token;
  if (!token) {
    setError("Invalid token. Please restart reset process.");
    return;
  }

  const result = await resetPassword(newPassword, token);

  if (result.success) {
    alert("Password Reset Success");
    navigate("/");
  }
};


  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 relative overflow-x-hidden overflow-y-auto">
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl mb-4 shadow-lg ring-2 ring-blue-500/30">
            <img
              src="https://cdn.acsdev.in/fynryx/acs.png"
              alt="ACS Logo"
              className="w-12 h-12 object-contain"
            />
          </div>
        </div>

        <div className="w-full bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl p-8">
        <h1 className="text-2xl font-bold text-center mb-4">Reset Password</h1>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700">New Password</label>
            <input
              type="password"
              required
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-xl px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter new password"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700">Confirm Password</label>
            <input
              type="password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-xl px-3 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Confirm new password"
            />
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}
          {message && <p className="text-green-600 text-sm">{message}</p>}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium rounded-xl hover:from-blue-600 hover:to-indigo-700 disabled:opacity-50 transition-all duration-200"
          >
            {isLoading ? "Resetting..." : "Reset Password"}
          </button>
        </form>

        <div className="mt-4 text-center text-sm">
          {/* <a href="/login" className="text-blue-600 hover:text-blue-500">Back to Login</a> */}
          <button
          type="button"
          onClick={() => navigate("/")}
          className="font-medium text-blue-600 hover:text-blue-500 transition-colors duration-200"
        >
          Back to Login
        </button>
        </div>
        </div>

        <footer className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            © 2025 Algorithmica Consultancy Services PVT LTD.
          </p>
          <p className="text-xs text-gray-500">All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
